<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
	<div class="form-group" cvModuleCxoneCustomSettingSection [moduleManager]="moduleManager" after="view">
		<label cvLocalizedText langSection="CXOne_Quality_Evaluations_Module" langKey="Report">Report</label>
		<cxone-singleselect-dropdown 
			*ngIf="definitions !== null" 
			[(ngModel)]="selectedReport" 
			[options]="definitions"
			[label]="'displayName'" 
			[primaryKey]="'ReportingSetName'" 
			[isRequired]="true" 
			[search]="false"
			[showFooter]="false" 
			(selectionChanged)="onReportSelected()">
		</cxone-singleselect-dropdown>
	</div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
	<div cvModuleCxoneCustomSettingSection after="emp" [moduleManager]="moduleManager">
		<div class="form-group">
			<label cvLocalizedText langSection="Controls" langKey="Groups">Groups</label>
			<cv-single-attribute-selector class="d-flex" attributeName="Agent Group" [attributeType]="1"
				[pageName]="moduleManager.getModuleKey() + '_temp'"></cv-single-attribute-selector>
		</div>
	</div>
</ng-container>